import {Link} from 'react-router-dom';
import {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button.jsx";
import ApiRequester from "./ApiRequester.jsx";
import {
    paginateData,
    sortFunc,
    formFail,
    handleSubmitActions,
    actionAppearance,
    deleteModalSingle,
    formClear,
    bulkDeleteModal,
    swapModal,
    checkAll,
    formCheck,
    formSuccess,
    formCheckWithElement,
    showModal,
    closeModal,
    hideModal,
    iAmHigherAuthority,
    areaLearninBehaviorToggle,
    isBannerPresent, versionSort, arrayComparison, headerFilterFunc, searchFunc, getZipRegexByCountry, getCountryData,
    getStatesByCountry
} from "../libs.jsx"
import {toast, ToastContainer} from "react-toastify";
import {Modal} from "bootstrap";
import {CSVLink} from "react-csv";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import BulkDeleteModal from "./component-assets/BulkDeleteModal.jsx";
import SingleDeleteModal from "./component-assets/SingleDeleteModal.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import Navigation from "./Navigation.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";
import { getSession, setSession, getActiveVendorIdList } from "../services/session";

const Areas = (props) => {
    let dData, bData, csvAreaHeaders, csvAreaGroupHeaders, csvBuildingHeaders, areaHeaderData, areaHeaderData2, groupHeaderData, groupHeaderData2,
        buildingHeaderData, countryOptions = [];

    dData = getSession();

    areaHeaderData = [
        {label: "Name", key: "area_name", align: "left", filtered: true,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Area Group", key: "area_group_name", align: "left", type: "ellipsis", filtered: true},
        {label: "Area Type", key: "area_type_description", align: "center", filtered: true},
        {label: "Residents", key: "residents", align: "center", filtered: true, filterKey: "resident_name",
            link: {enabled: true, linkto: "/profiles/resident", linkkey: "resident_id", type: "obj", displayKey: ["resident_name"]}},
        {label: "Devices", key: "devices", align: "center", filtered: true, filterKey: "description",
            link: {enabled: true, type: "conditional-obj", conditionKey: "mid", displayKey: "description",
                condition: {"1": {linkto: "/profiles/inovonics", linkkey: "device_id", displayKey: "description"},
                            "4": {linkto: "/profiles/palcare", linkkey: "device_id", displayKey: "description"}}}}
    ];

    areaHeaderData2 = [
        {label: "Area Name", key: "area_name", align: "left",
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id",
                inmodal: true, modalKey: "cancelEditAreaGroupBtn"}},
        {label: "Area Type", key: "area_type_description", align: "left"},
        {label: "Current Occupancy", key: "number_residents", align: "center"},
    ];

    groupHeaderData = [
        {label: "Group", key: "area_group_name", align: "left", filtered: true},
        {label: "Description", key: "area_group_description", align: "left", filtered: true},
        {label: "Areas", key: "area_name", align: "left", type: "ellipsis"}
    ];

    groupHeaderData2 = [
        {label: "Group", key: "area_group_name", align: "left"},
        {label: "Description", key: "area_group_description", align: "left"}
    ];

    buildingHeaderData = [
        {label: "Name", key: "building_name", align: "left", filtered: true},
        {label: "Street Address", key: "street_address", align: "left", filtered: true},
        {label: "City", key: "city", align: "center", filtered: true},
        {label: "State", key: "state", align: "center", filtered: true},
        {label: "Zip", key: "zipcode", align: "center", filtered: true},
        {label: "Country", key: "country", align: "center", filtered: true},
    ]

    csvAreaHeaders = [
        {label: "Name", key: "area_name"},
        {label: "Area Group", key: "area_group_name"},
        {label: "Area Type", key: "area_type_description"},
        {label: "Max Occupancy", key: "max_occupancy"},
        {label: "Building", key: "building_name"},
        {label: "Devices", key: "description"}
    ];
    csvAreaGroupHeaders = [
        {label: "Group", key: "area_group_name"},
        {label: "Description", key: "area_group_description"},
        {label: "Areas", key: "area_name"}
    ];
    csvBuildingHeaders = [
        {label: "Name", key: "building_name"},
        {label: "Street Address", key: "street_address"},
        {label: "City", key: "city"},
        {label: "State", key: "state"},
        {label: "Zip", key: "zipcode"},
        {label: "Country", key: "country"}
    ];

    if (iAmHigherAuthority(99, dData?.role_weight)){
        csvAreaHeaders.splice(0, 0, {label: "Area ID", key: "area_id"});
        csvAreaGroupHeaders.splice(0, 0, {label: "Area Group ID", key: "area_group_id"});
        csvBuildingHeaders.splice(0, 0, {label: "Building ID", key: "building_id"});
    }

    // Standard Page Variables
    const [tabItem, setTabItem] = useState("init");
    const [read, setRead] = useState(true);
    const [addRights, setAddRights] = useState(iAmHigherAuthority(20, dData?.role_weight));
    const [editRights, setEditRights] = useState(iAmHigherAuthority(20, dData?.role_weight));
    const [devEditRights, setDevEditRights] = useState(iAmHigherAuthority(10, dData?.role_weight));
    const [deleteRights, setDeleteRights] = useState(iAmHigherAuthority(20, dData?.role_weight));
    const [count, setCount] = useState(0);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [page3, setPage3] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storedIndex, setStoredIndex] = useState(0);
    const [search, setSearch] = useState(""); // Search on main tables
    const [search2, setSearch2] = useState(""); // Search on modal tables
    const [showChecked, setShowChecked] = useState(false);

    // Area Tab Section
    const [areaOrigin, setAreaOrigin] = useState([]);
    const [areaActive, setAreaActive] = useState([]);
    const [areaTableRows, setAreaTableRows] = useState([]);
    const [areaHeaderFilters, setAreaHeaderFilters] = useState([]);
    const [areaIdList, setAreaIdList] = useState([]);
    const [oldAreaIdList, setOldAreaIdList] = useState([]);
    const [groupDataCnt, setGroupDataCnt] = useState(0);
    const [groupTableRows2, setGroupTableRows2] = useState([]);
    const [areaGroupIdList2, setAreaGroupIdList2] = useState([]);
    const [oldAreaGroupIdList2, setOldAreaGroupIdList2] = useState([]);
    const [addTabItem, setAddTabItem] = useState("single");
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter, setSorter] = useState({
        sortColumn: "area_name",
        sortOrder: "asc"
    });

    // Area Group Section
    const [areaGroupOrigin, setAreaGroupOrigin] = useState([]);
    const [areaGroupActive, setAreaGroupActive] = useState([]);
    const [groupTableRows, setGroupTableRows] = useState([]);
    const [areaTableRows2, setAreaTableRows2] = useState([]);
    const [areaGroupHeaderFilters, setAreaGroupHeaderFilters] = useState([]);
    const [areaGroupIdList, setAreaGroupIdList] = useState([]);
    const [oldAreaGroupIdList, setOldAreaGroupIdList] = useState([]);
    const [areaIdList2, setAreaIdList2] = useState([]);
    const [oldAreaIdList2, setOldAreaIdList2] = useState([]);
    const [areaDataCnt, setAreaDataCnt] = useState(0);
    const [ppRules2, setPRules2] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter2, setSorter2] = useState({
        sortColumn: "area_group_name",
        sortOrder: "asc"
    });

    // Building Section
    const [buildingOrigin, setBuildingOrigin] = useState([]);
    const [buildingActive, setBuildingActive] = useState([]);
    const [buildingHeaderFilters, setBuildingHeaderFilters] = useState([]);
    const [buildingTableRows, setBuildingTableRows] = useState([]);
    const [buildingIdList, setBuildingIdList] = useState([]);
    const [oldBuildingIdList, setOldBuildingIdList] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [zipReg, setZipReg] = useState(getZipRegexByCountry("US"));
    const [ppRules3, setPRules3] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter3, setSorter3] = useState({
        sortColumn: "name",
        sortOrder: "asc"
    });

    // Page Load Variables
    const [areaDataLoaded, setAreaDataLoaded] = useState(false);
    const [areaTypesLoaded, setAreaTypesLoaded] = useState(false);
    const [areasLoaded, setAreasLoaded] = useState(false);
    const [areaGroupDataLoaded, setAreaGroupDataLoaded] = useState(false);
    const [areaGroupLoaded, setAreaGroupLoaded] = useState(false);
    const [buildingDataLoaded, setBuildingDataLoaded] = useState(false);
    const [buildingLoaded, setBuildingLoaded] = useState(false);
    const [devicesLoaded, setDevicesLoaded] = useState(false);
    const [devCatLoaded, setDevCatLoaded] = useState(false);
    const [devTypeLoaded, setDevTypeLoaded] = useState(false);

    // Device asset variables
    const [deviceData, setDeviceData] = useState([]);
    const [editDeviceList, setEditDeviceList] = useState([]);
    const [editSystemDeviceList, setEditSystemDeviceList] = useState([]);

    // Device Learn in Variables
    const [listening, setListening] = useState(false); // Flag indicating listening started, stopped
    const [listenEnabled, setListenEnabled] = useState(false); // Flag if listen feature ready or not
    const [listenCount, setListenCount] = useState(60);  // Counter for fetching and toggle listen off
    const [listenData, setListenData] = useState([]);  // Data response of devices heard
    const [listenList, setListenList] = useState([]); // Drop down options for heard devices serial numbers
    const [deviceCatData, setDeviceCatData] = useState([]);  // Device category data used for drop down in learn in
    const [deviceCatOptions, setDeviceCatOptions] = useState([]);  // Device category drop down options for learn in
    const [deviceTypeData, setDeviceTypeData] = useState([]); // Data used for device type drop down in learn in
    const [deviceTypeOptions, setDeviceTypeOptions] = useState([]); // Device type drop down options for learn in
    const [deviceCatId, setDeviceCatId] = useState(0);  // Device Category set in learn in
    const [deviceTypeId, setDeviceTypeId] = useState([]);  // Device Type set in learn in
    const [modelId, setModelId] = useState(0);  // Model selected in list
    const [modelOptions, setModelOptions] = useState([]);
    const [msgClass, setMsgClass] = useState(0);
    const [productCode, setProductCode] = useState(0);
    const [marketId, setMarketId] = useState(0);
    const [allProductCodes, setAllProductCodes] = useState([]);
    const [showDeviceList, setShowDeviceList] = useState(false); // Toggles showing drop down serial or not and required validation
    const [listenDevice, setListenDevice] = useState("");
    const [deviceTypeName, setDeviceTypeName] = useState("");
    const [listenPCode, setListenPCode] = useState(0);
    const [useOptions, setUseOptions] = useState([]);
    const [useId, setUseId] = useState(0);
    const [showAlarmBehaviors, setShowAlarmBehaviors] = useState(false);
    const [deviceImg, setDeviceImg] = useState("");

    // Area Type Data and dd Vars
    const [areaTypes, setAreaTypes] = useState([]);
    const [areaDd, setAreaDd] = useState([]);
    const [assignedArea, setAssignedArea] = useState("");
    const [areaTypeSorter, setAreaTypeSorter] = useState({
        sortColumn: "area_type_name",
        sortOrder: "asc"
    });

    // Other Enact Once Variables
    const [csvLink, setLink] = useState({
        filename: "Areas.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    const countries = getCountryData();
    for (let i2=0; i2 < countries?.length; i2++){
        countryOptions.push(
            <option key={"country-option-"+i2} value={countries[i2][0]}>{countries[i2][1]}</option>
        );
    }

    if (buildingOrigin.length > 0){
        areaHeaderData.splice(1, 0, {label: "Address", key: ["building_name", "street_address"], align: "center", type: "stack-muted",
            filtered: true, filterKey: "building_name", sorts: true, sortKey: "street_address"})
    }

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "sp_dev_getdeviceandgroupforareabycampus", reqType: "stored"}).then(data => {
                setAreaOrigin(data);
                setAreaDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_area_type",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setAreaTypes(data);
                setAreaTypesLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "sp_dev_getareagroupandareabycampusid", reqType: "stored"}).then(data => {
                setAreaGroupOrigin(data);
                setAreaGroupDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: "",
                                device_category_filter: "1,2,3,4,5,6,7,8,9,10,11,12,15,16,17", campus_id: campusId},
                                procedure: "sp_dev_getInovonicsDevices", reqType: "stored", "read-only": true}).then(data => {
                setDeviceData(data);
                setDevicesLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getareadevicecategories", reqType: "stored", "read-only": true}).then(data => {
                setDeviceCatData(data);
                setDevCatLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getinovonicsdevicetypes", reqType: "stored", "read-only": true}).then(data => {
                setDeviceTypeData(data);
                setDevTypeLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, payload: {campus_id: campusId},
                                procedure: "getbuildingsandareas", reqType: "stored", "read-only": read}).then(data => {
                setBuildingOrigin(data);
                setBuildingDataLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        if (tabItem === "areas"){
            setLink(prevState => {
                return {
                    filename: "Areas.csv",
                    headers: csvAreaHeaders,
                    data: areaOrigin}
            });
        }else if (tabItem === "areagroups"){
            setLink(prevState => {
                return {
                    filename: "Areas_Groups.csv",
                    headers: csvAreaGroupHeaders,
                    data: areaGroupOrigin}
            });
        }else if (tabItem === "buildings"){
            setLink(prevState => {
                return {
                    filename: "Buildings.csv",
                    headers: csvBuildingHeaders,
                    data: buildingOrigin}
            });
        }
    }, [areaOrigin, areaGroupOrigin, buildingOrigin, tabItem]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                        class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [csvLink]);

    useEffect(() => {
        if (areasLoaded){
            if (tabItem === "init") {
                setTabItem("areas");
            }
        }
    }, [areasLoaded]);

    useEffect(() => {
        if ([areaDataLoaded, areaGroupDataLoaded, areaTypesLoaded, devicesLoaded].every((item) => item === true)){
            setAreasLoaded(true);
        }
    }, [areaDataLoaded, areaTypesLoaded, areaGroupDataLoaded, devicesLoaded]);

    useEffect(() => {
        if ([areaDataLoaded, areaGroupDataLoaded, areaTypesLoaded, devicesLoaded].every((item) => item === true)){
            setAreaGroupLoaded(true);
        }
    }, [areaGroupDataLoaded, areaDataLoaded, areaTypesLoaded, devicesLoaded]);

    useEffect(() => {
        let tmp = [];
        if ([buildingDataLoaded].every((item) => item === true)){
            if (buildingOrigin && buildingOrigin.length > 0){
                setCountryOptionsFunction(buildingOrigin[0].country);
            }else {
                setCountryOptionsFunction("US");
            }
            for (let i = 0; i < buildingOrigin.length; i++) {
                tmp.push(<option title={`${buildingOrigin[i].street_address} \n${buildingOrigin[i].city} ${buildingOrigin[i].state} ${buildingOrigin[i].zipcode}`}
                                 value={buildingOrigin[i].building_id}>
                    {buildingOrigin[i].building_name}
                </option>)
            }
            setBuildingOptions(tmp);
            setBuildingLoaded(true);
        }
    }, [buildingDataLoaded]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(areaOrigin, areaHeaderFilters, areaHeaderData);

        searchKeys = ["area_name", "area_type_description", "area_group_name", "description", "resident_name",
            "max_occupancy", "area_type_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setAreaActive(tmpData);
    }, [search, areaOrigin, areaHeaderFilters]);

    useEffect(() => {
        let pRules = paginateData(areaActive, page, perPage);
        setPRules(pRules);
        if (areaActive.length > 0) {
            areaActive.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setAreaTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={areaActive} checkbox={deleteRights}
                                writeAccess={editRights} unk={"a-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteAreaBtn"])}
                                tableHeaders={areaHeaderData} editModal={editAreaModal} modal={editRights} checkboxId={"uCheck"}
                                parentComponent={"Areas"} dData={dData} checkboxlist={areaIdList}
                                setCheckboxId={(value) => {setAreaIdList(value)}} checkidkey={"area_id"} />);
    }, [areaActive, sorter, areaIdList, page, perPage, tabItem]);

    useEffect(() => {
        let tmpData, searchKeys;
        // Handles Area Group Edit Area Table

        searchKeys = ["area_name", "area_type_description", "number_residents"];
        tmpData = searchFunc(search2, areaOrigin, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return areaIdList2.includes(item.area_id.toString())})
        }
        setAreaDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        setAreaTableRows2(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                    actionAppearance={() => {}} tableHeaders={areaHeaderData2} checkboxId={"uCheck2_"}
                                    parentComponent={"Areas"} dData={dData} checkboxlist={areaIdList2}
                                    modal={false} editModal={() => {}} unk={"b-"}
                                    setCheckboxId={(value) => {setAreaIdList2(value)}} checkidkey={"area_id"} />);
    }, [areaOrigin, areaIdList2, sorter, search2, showChecked]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(areaGroupOrigin, areaGroupHeaderFilters, groupHeaderData);

        searchKeys = ["area_group_name", "area_group_description", "area_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page2, perPage);
        if (search && page2 > pRules.pageMax){
            setPage2(pRules.pageMax);
        }else if (!search){
            setPage2(storePage);
        }
        setPRules2(pRules);
        setAreaGroupActive(tmpData);
    }, [search, areaGroupOrigin, areaGroupHeaderFilters]);

    useEffect(() => {
        // Handling the Main groups tab table on screen
        let pRules = paginateData(areaGroupActive, page2, perPage);
        setPRules2(pRules);
        if (areaGroupActive.length > 0) {
            areaGroupActive.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        }
        setGroupTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={areaGroupActive} checkbox={true} writeAccess={editRights} unk={"c-"}
                                     actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteAreaGroupBtn"], "uCheckGroup")}
                                     tableHeaders={groupHeaderData} checkboxId={"uCheckGroup"}
                                     parentComponent={"Areas"} dData={dData} checkboxlist={areaGroupIdList} modal={true} editModal={editAreaGroupModal}
                                     setCheckboxId={(value) => {setAreaGroupIdList(value)}} checkidkey={"area_group_id"} />);
    }, [areaGroupActive, areaGroupIdList, sorter2, areaActive, page2, perPage, tabItem]);

    useEffect(() => {
        let tmpData, searchKeys;
        // Handling the edit table on areas

        searchKeys = ["area_group_name", "area_group_description"];
        tmpData = searchFunc(search2, areaGroupOrigin, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return areaGroupIdList2.includes(item.area_group_id.toString())})
        }
        setGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        setGroupTableRows2(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={editRights} unk={"d-"}
                                     actionAppearance={() => {}} tableHeaders={groupHeaderData2} checkboxId={"uCheckGroup2_"}
                                     parentComponent={"Areas"} dData={dData} checkboxlist={areaGroupIdList2} modal={false} editModal={() => {}}
                                     setCheckboxId={(value) => {setAreaGroupIdList2(value)}} checkidkey={"area_group_id"} />);
    }, [areaGroupOrigin, areaGroupIdList2, sorter2, search2, areaActive, showChecked]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(buildingOrigin, buildingHeaderFilters, buildingHeaderData);

        searchKeys = ["name", "street_address"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page3, perPage);
        if (search && page3 > pRules.pageMax){
            setPage3(pRules.pageMax);
        }else if (!search){
            setPage3(storePage);
        }
        setPRules3(pRules);
        setBuildingActive(tmpData);
    }, [search, buildingOrigin, buildingHeaderFilters]);

    useEffect(() => {
        // Handling the Main building tab table on screen
        let pRules = paginateData(buildingActive, page3, perPage);
        setPRules3(pRules);
        if (buildingActive.length > 0) {
            buildingActive.sort((a, b) => sortFunc(a, b, sorter3.sortColumn, sorter3.sortOrder));
        }
        setBuildingTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={buildingActive} checkbox={true} writeAccess={editRights} unk={"e-"}
                                     actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBuildingBtn"], "uCheckBuilding")}
                                     tableHeaders={buildingHeaderData} checkboxId={"uCheckBuilding"}
                                     parentComponent={"Areas"} dData={dData} checkboxlist={buildingIdList} modal={true} editModal={editBuildingModal}
                                     setCheckboxId={(value) => {setBuildingIdList(value)}} checkidkey={"building_id"} />);
    }, [buildingActive, buildingIdList, sorter3, page3, perPage, tabItem]);

    useEffect(() => {
        if (areaTypes.length > 0){
            let tmpOptions = [];
            areaTypes.sort((a, b) => sortFunc(a, b, areaTypeSorter.sortColumn, areaTypeSorter.sortOrder));
            for (let i=0; i<areaTypes.length; i++){
                tmpOptions.push(
                    <option key={`area-type-option-${areaTypes[i].area_type_id}`}
                            value={areaTypes[i].area_type_id}>{areaTypes[i].area_type_description}
                    </option>
                );
            }
            setAreaDd(() => tmpOptions);
        }
    }, [areaTypes]);

    useEffect(() => {
        if (deviceCatData.length > 0){
            let tmpOptions = []
            for (let i=0; i < deviceCatData.length; i++){
                tmpOptions.push(
                    <option key={`device-category-option-${deviceCatData[i].device_category_id}`}
                            value={deviceCatData[i].device_category_id}>{deviceCatData[i].device_category_short_name}
                    </option>
                );
            }
            setDeviceCatOptions(() => tmpOptions);
        }
    }, [deviceCatData]);

    useEffect(() => {
        let i, tmp = [];
        deviceTypeData.sort((a, b) => sortFunc(a, b, "device_type_name", "asc"));
        for (i = 0; i < deviceTypeData.length; i++){
            if ((deviceTypeData[i]?.device_category_id.toString() === deviceCatId.toString()) &&
                (iAmHigherAuthority(80, dData?.role_weight) || !deviceTypeData[i]?.is_third_party)){
                tmp.push(
                    <option key={`device-use-option-${deviceTypeData[i]?.inovonics_type_id}`}
                            style={{background: `url(/static/image/water_resistant_pendant.png)`}}
                            value={deviceTypeData[i]?.inovonics_type_id}>{deviceTypeData[i]?.device_type_name}
                    </option>
                );
            }
        }

        setDeviceTypeOptions(() => tmp);
    }, [deviceTypeData, deviceCatId]);

    useEffect(() => {
        let tmp = [], models = [], tmp2 = [], uses = [], tmp3 = [], imgstr = "";
        for (let i = 0; i < deviceTypeData.length; i++) {
            if (deviceTypeData[i]?.inovonics_type_id === deviceTypeId){
                models = deviceTypeData[i]?.models ? deviceTypeData[i].models : [];
                uses = deviceTypeData[i]?.uses ? deviceTypeData[i].uses : [];
                imgstr = deviceTypeData[i]?.image_url ? deviceTypeData[i].image_url : "";
                break
            }
        }
        for (let i2=0; i2 < models.length; i2++){
            if (i2 === 0){
                setModelId(models[i2].model_id);
                setMsgClass(models[i2].message_class);
                setProductCode(models[i2].product_type_id);
                setMarketId(models[i2].market_id);
            }
            tmp2.push(models[i2].product_type_id);
            tmp.push(
                <option key={`device-model-option-${i2}`}
                        value={models[i2]?.model_id}>{models[i2]?.model_name}
                </option>
            );
        }
        for (let i3=0; i3 < uses.length; i3++){
            if (i3 === 0){
                setUseId(uses[i3].inovonics_device_use_id);
                setShowAlarmBehaviors(uses[i3].option_number !== 0);
            }
            if (uses[i3].option_number !== 0){
                tmp3.push(
                    <div className={"form-check form-switch mt-1"} id={`use-option-${uses[i3].option_number}-container`}>
                        <input className={"form-check-input"} id={`use-option-${uses[i3].option_number}`} type={"radio"}
                               name={"alarmBehavior"} value={uses[i3].inovonics_device_use_id} defaultChecked={i3 === 0}
                               onChange={(e) => {setUseId(parseInt(e.target.value))}} />
                        <label className={"form-check-label me-4 mt-1 text-dark"}
                               htmlFor={`use-option-${uses[i3].option_number}`} id={`use-option-label-${uses[i3].option_number}`}>
                            {uses[i3].option_text}
                        </label>
                    </div>
                );
            }
        }
        setAllProductCodes(tmp2);
        setModelOptions(() => tmp);
        setUseOptions(() => tmp3);
        setDeviceImg(imgstr);
    }, [deviceTypeData, deviceTypeId]);

    useEffect(() => {
        let models = [];
        for (let i = 0; i < deviceTypeData.length; i++) {
            if (deviceTypeData[i]?.inovonics_type_id === deviceTypeId) {
                models = deviceTypeData[i]?.models ? deviceTypeData[i].models : [];
                break;
            }
        }
        for (let i2 = 0; i2 < models.length; i2++) {
            if (models[i2].model_id === modelId) {
                setMsgClass(models[i2].message_class);
                setProductCode(models[i2].product_type_id);
                setMarketId(models[i2].market_id);
            }
        }
        setListenEnabled(modelId !== 0);
    }, [modelId]);

    useEffect(() => {
        buildDeviceList(-1);
    }, [areaActive]);

    useEffect(() => {
        let interval;
        if (checkListenValid()){
            interval = setInterval(() => {
                setListenCount(listenCount  => listenCount  + 1);
            }, 1000);
            if (listenCount < 60){
                if (listenCount % 4 === 0){
                    ApiRequester({reqEndpoint: "getitems", Table: "LearnIn", PKey: "ClientId",
                        PVal: dData.sessionId, CampusId: campusId}).then(data => {
                            setListenData(data);
                    });
                }
            }
            if (listenCount === 60){
                setListening(false);
                toast.info("Capture timeout, restart capture if device not in list.");
            }
        }
        return () => clearInterval(interval);
    }, [listenCount]);

    useEffect(() => {
        let tmpList = [];
        for (let i=0; i < listenData.length; i++){
            tmpList.push(
                <option key={`listen-${listenData[i]?.trx_id}`} value={[listenData[i]?.trx_id, listenData[i]?.pType]}>
                    {listenData[i]?.name} ({listenData[i]?.trx_id})
                </option>
            );
        }
        setListenList(tmpList);
        if (listenDevice === "" && listenData.length > 0){
            setListenDevice(() => listenData[0]?.trx_id);
            setListenPCode(() => listenData[0]?.pType);
            toast.success("Devices found.");
        }
    }, [listenData]);

    useEffect(() => {
        formCheck("pendantForm", "pendantSubmit");
    }, [listening, listenDevice]);

    function checkListenValid(){
        return [listening, deviceCatId !== 0, deviceTypeId !== 0].every((item) => item === true);
    }

    function editAreaModal(editIndex){
        let name, dataIndex, locId, modal, delBtn, groupIdList = [];
        if (editRights){
            setShowChecked(false);
            dataIndex = parseInt(editIndex);
            setSearch2("");
            setStoredIndex(dataIndex);
            buildDeviceList(dataIndex);
            name = document.getElementById("nameE");
            locId = document.getElementById("areaIdE");
            document.getElementById("livingcapE").value = areaActive[dataIndex]?.max_occupancy;
            document.getElementById("areaTypeE").value = areaActive[dataIndex]?.area_type_id;
            document.getElementById("buildingE").value = areaActive[dataIndex]?.building_id;
            name.value = areaActive[dataIndex]?.area_name;
            locId.value = areaActive[dataIndex]?.area_id;
            for (let i2=0; i2 < areaActive[dataIndex]?.area_groups?.length; i2++){
                groupIdList.push(areaActive[dataIndex]?.area_groups[i2]?.area_group_id.toString());
            }
            setAreaGroupIdList2(groupIdList);
            setOldAreaGroupIdList2(groupIdList);
            document.getElementById("uCheckHead2").checked = groupIdList && groupIdList.length === areaGroupOrigin.length;
            delBtn = document.getElementById("deleteSingleAreaBtn");
            delBtn.onclick = () => {
                setDContent([[locId.value, ""]]);
                deleteModalSingle(name.value, name.value, "cancelEditAreaBtn");
            };
            formCheck("editAreaForm", "editAreaSubmit");
            modal = new Modal(document.getElementById("editareamodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function editAreaGroupModal(editIndex){
        let groupId, groupname, dataIndex, modal, delBtn, aIdList = [];
        if (editRights){
            setShowChecked(false);
            dataIndex = parseInt(editIndex);
            setSearch2("");
            setStoredIndex(dataIndex);
            groupname = document.getElementById("groupNameE");
            groupId = document.getElementById("groupIdE");
            document.getElementById("descriptionE").value = areaGroupActive[dataIndex]?.area_group_description;
            for (let i = 0; i < areaGroupActive[dataIndex]?.areas?.length; i++){
                aIdList.push(areaGroupActive[dataIndex]?.areas[i]?.area_id.toString());
            }
            setAreaIdList2(aIdList);
            setOldAreaIdList2(aIdList);
            document.getElementById("uCheckHead5").checked = aIdList && aIdList.length === areaOrigin.length;
            groupname.value = areaGroupActive[dataIndex]?.area_group_name;
            groupId.value = areaGroupActive[dataIndex]?.area_group_id;
            delBtn = document.getElementById("deleteSingleAreaGroupBtn");
            delBtn.onclick = () => {
                setDContent([[groupId.value, ""]]);
                deleteModalSingle(groupname.value, groupname.value, "cancelEditAreaGroupBtn");
            };
            formCheck("editAreaGroupForm", "editAreaGroupSubmit");
            modal = new Modal(document.getElementById("editareagroupmodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function editBuildingModal(editIndex){
        let dataIndex, modal, delBtn, aIdList = [], buildId, name;
        if (editRights){
            setShowChecked(false);
            dataIndex = parseInt(editIndex);
            setSearch2("");
            setStoredIndex(dataIndex);
            name = document.getElementById("buildingnameE");
            buildId = document.getElementById("buildingIdE");
            setCountryOptionsFunction(buildingActive[dataIndex]?.country);
            document.getElementById("buildingcountryE").value = buildingActive[dataIndex]?.country;
            document.getElementById("buildingstateE").value = buildingActive[dataIndex]?.state;
            document.getElementById("buildingaddressE").value = buildingActive[dataIndex]?.street_address;
            document.getElementById("buildingcityE").value = buildingActive[dataIndex]?.city;
            document.getElementById("buildingzipE").value = buildingActive[dataIndex]?.zipcode;
            for (let i = 0; i < buildingActive[dataIndex]?.areas?.length; i++){
                aIdList.push(buildingActive[dataIndex]?.areas[i]?.area_id.toString());
            }
            setAreaIdList2(aIdList);
            setOldAreaIdList2(aIdList);
            document.getElementById("uCheckHead9").checked = aIdList && aIdList.length === areaOrigin.length;
            name.value = buildingActive[dataIndex]?.building_name;
            buildId.value = buildingActive[dataIndex]?.building_id;
            delBtn = document.getElementById("deleteSingleBuildingBtn");
            delBtn.onclick = () => {
                setDContent([[buildId.value, ""]]);
                deleteModalSingle(name.value, name.value, "cancelEditBuildingBtn");
            };
            formCheck("editBuildingForm", "editBuildingSubmit");
            modal = new Modal(document.getElementById("editbuildingmodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function removeDevice(deviceIdList){
        let payload = [], oldPayload = [];
        if (devEditRights){
            for (let i=0; i < deviceIdList.length; i++){
                payload.push({device_id: deviceIdList[i], is_active: false, area_id: null, modified_by: dData.user});
                oldPayload.push({device_id: deviceIdList[i], area_id: areaActive[storedIndex].area_id});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "device_unassign_area", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                if (data && data[0] === true){
                    setRead(false);
                    setCount(0);
                    toast.success("Devices have been removed");
                }
                else{
                    toast.error("Failed to remove devices");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function buildDeviceList(dataIndex){
        let tmp = [], tmp2 = [];
        if (dataIndex === -1){
            dataIndex = storedIndex;
        }
        for (let i=0; i < areaActive[dataIndex]?.devices?.length; i++){
            if ([4, 5, 13, 14, 0, null, undefined].includes(areaActive[dataIndex]?.devices[i]?.device_category_id)){
                tmp2.push(
                    <tr key={`tr-item-${areaActive[dataIndex]?.devices[i].device_id}`}>
                        {editRights &&
                            <td>
                                <i className={"fe fe-trash-2 red-hover fs-2 me-3 align-text-bottom"}
                                   onClick={() => removeDevice([areaActive[dataIndex]?.devices[i].device_id])}/>
                            </td>
                        }
                        <td className={"fs-5"}>
                            <span>{areaActive[dataIndex]?.devices[i].device_name} </span><span>{areaActive[dataIndex]?.devices[i].descriptions}</span><span> ({areaActive[dataIndex]?.devices[i].manufacture_uuid})</span>
                        </td>
                    </tr>
                );
            }else{
                tmp.push(
                    <tr key={`tr-item-${areaActive[dataIndex]?.devices[i].device_id}`}>
                        {devEditRights &&
                            <td className={"fs-5"}>
                                <i className={"fe fe-trash-2 red-hover fs-2 me-3 align-text-bottom"}
                                   onClick={() => removeDevice([areaActive[dataIndex]?.devices[i].device_id])}/>
                            </td>
                        }
                        <td className={"fs-5"}>
                            <Link to={`/profiles/inovonics/${areaActive[dataIndex]?.devices[i].device_id}`}
                                  onClick={() => closeModal("cancelEditAreaBtn")}>
                                <span>{areaActive[dataIndex]?.devices[i].device_name} </span><span>{areaActive[dataIndex]?.devices[i].descriptions}</span><span> ({areaActive[dataIndex]?.devices[i].manufacture_uuid})</span>
                            </Link>
                        </td>
                    </tr>
                );
            }
        }
        setEditDeviceList(tmp);
        setEditSystemDeviceList(tmp2);
    }

    function setCountryOptionsFunction(inCountry){
        let tmp = [];
        let stateData = getStatesByCountry(inCountry);
        for (let i=0; i < stateData?.length; i++){
            tmp.push(
                <option key={"state-option"+i} value={stateData[i][0]}>{stateData[i][1]}</option>
            );
        }
        setStateOptions(tmp);
        setZipReg(getZipRegexByCountry(inCountry));
    }

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        setAreaIdList([]);
        dData.perPage = tmpPerPage;
        setPage(1);
        setSession(dData);
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function formAddAreaSubmit(){
        // User add form submit function
        let name, livingcap, payload, areaTypeId, buildingId;
        if (addRights){
            handleSubmitActions("addAreaSubmit", "loadAddAreaSubmit");
            name = document.getElementById("name").value;
            livingcap = document.getElementById("livingcap").value;
            areaTypeId = document.getElementById("areaType").value;
            buildingId = document.getElementById("building").value;
            payload = [{area_name: name, campus_id: campusId, max_occupancy: parseInt(livingcap),
                        area_type_id: parseInt(areaTypeId), area_group_ids: areaGroupIdList,
                        building_id: parseInt(buildingId),
                        vendor_ids: getActiveVendorIdList(),
                        }];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "area_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setAreaIdList([]);
                    formSuccess(`${name} has been added.`, "addAreaSubmit", "loadAddAreaSubmit", "cancelAddAreaBtn", "addAreaForm");
                    setRead(false);
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addAreaSubmit", "loadAddAreaSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddBulkSubmit(){
        // User add form submit function
        let name, livingcap, payload = [], areaTypeId, start, end, roomcnt = 0, buildingId;
        if (addRights){
            handleSubmitActions("addBulkSubmit", "loadAddBulkSubmit");
            name = document.getElementById("name-bulk").value;
            livingcap = document.getElementById("livingcap-bulk").value;
            areaTypeId = document.getElementById("areaType-bulk").value;
            buildingId = document.getElementById("building-bulk").value;
            start = parseInt(document.getElementById("add-start-bulk").value);
            end = parseInt(document.getElementById("add-end-bulk").value);
            roomcnt = end-start
            if (roomcnt <= 500){
                for (let i=0; i<=roomcnt; i++){
                    payload.push({area_name: `${name}${start+i}`, campus_id: campusId, max_occupancy: parseInt(livingcap),
                                area_type_id: parseInt(areaTypeId), area_group_ids: areaGroupIdList,
                                building_id: parseInt(buildingId),
                                vendor_ids: getActiveVendorIdList(),
                                });
                }
                ApiRequester({reqEndpoint: "mytransaction", TransType: "area_add", Payload: payload,
                                    CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                    if (data[0] === true){
                        setAreaIdList([]);
                        formSuccess(`${name}${start} - ${name}${end} have been added.`, "addBulkSubmit", "loadAddBulkSubmit", "cancelAddBulkBtn", "addBulkForm");
                        setRead(false);
                        setCount(0);
                    }
                    else{
                        formFail(`Error during add, error code: ${data[1]}`, "addBulkSubmit", "loadAddBulkSubmit");
                    }
                });
            }else{
                toast.warn("Room count exceeds 500, reduce to add a maximum of 500 rooms at a time.");
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    // * * * * * * * * * * * * * * * * * * *
    // All Function For User Edit Behavior
    // * * * * * * * * * * * * * * * * * * *

    function formEditAreaSubmit(){
        // Location add form submit function
        let name, livingcap, payload, locUnqId, areaTypeId, oldName, oldLivingCap, oldCampusId, oldAreaTypeId,
            oldPayload, buildingId, oldBuildingId;
        if (editRights){
            name = document.getElementById("nameE").value;
            livingcap = document.getElementById("livingcapE").value;
            locUnqId = document.getElementById("areaIdE").value;
            areaTypeId = document.getElementById("areaTypeE").value;
            buildingId = document.getElementById("buildingE").value;
            oldName = areaActive[storedIndex]?.area_name;
            oldLivingCap = areaActive[storedIndex]?.max_occupancy;
            oldAreaTypeId = areaActive[storedIndex]?.area_type_id;
            oldCampusId = areaActive[storedIndex]?.campus_id;
            oldBuildingId = areaActive[storedIndex]?.building_id;
            if (arrayComparison([name, parseInt(livingcap), parseInt(areaTypeId), parseInt(buildingId)], [oldName, oldLivingCap, oldAreaTypeId, oldBuildingId])
                || arrayComparison(areaGroupIdList2.sort(), oldAreaGroupIdList2.sort())){
                handleSubmitActions("editAreaSubmit", "loadEditAreaSubmit");
                payload = [{area_id: locUnqId, area_name: name, max_occupancy: parseInt(livingcap), building_id: parseInt(buildingId),
                            area_type_id: parseInt(areaTypeId), area_group_ids: areaGroupIdList2, campus_id: campusId,
                            vendor_ids: getActiveVendorIdList(),
                            }];
                oldPayload = [{area_id: locUnqId, area_name: oldName, max_occupancy: oldLivingCap, building_id: oldBuildingId,
                               area_type_id: oldAreaTypeId, area_group_ids: oldAreaGroupIdList2, campus_id: oldCampusId}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "area_edit", Payload: payload,
                                    CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                    ClientId: dData.sessionId}).then(data => {
                        if (data[0]){
                            setAreaIdList([]);
                            formSuccess(`${name} updated.`, "editAreaSubmit", "loadEditAreaSubmit", "cancelEditAreaBtn");
                            setRead(false);
                            setCount(0);
                        }
                        else{
                            formFail(`Error during save, error code: ${data[1]}`, "editAreaSubmit", "loadEditAreaSubmit");
                        }
                });
            }else{
                toast.info("No change")
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddAreaGroupSubmit(){
        // User add form submit function
        let groupname, payload, description;
        if (addRights){
            handleSubmitActions("addAreaGroupSubmit", "loadAddAreaGroupSubmit");
            groupname = document.getElementById("groupname").value;
            description = document.getElementById("description").value;
            payload = [{campus_id: campusId, area_group_name: groupname, area_group_description: description,
                        area_ids: areaIdList2}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "area_group_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setAreaGroupIdList([]);
                    formSuccess("Group has been added.", "addAreaGroupSubmit", "loadAddAreaGroupSubmit", "cancelAddAreaGroupBtn", "addAreaGroupForm");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addAreaGroupSubmit", "loadAddAreaGroupSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditAreaGroupSubmit(){
        // User add form submit function
        let groupId, groupname, description, payload, oldGroupName, oldDescription, oldPayload;
        if (editRights){
            handleSubmitActions("editAreaGroupSubmit", "loadEditAreaGroupSubmit");
            groupId = document.getElementById("groupIdE").value;
            groupname = document.getElementById("groupNameE").value;
            description = document.getElementById("descriptionE").value;
            oldGroupName = areaGroupActive[storedIndex]?.area_group_name;
            oldDescription = areaGroupActive[storedIndex]?.area_group_description;
            if (arrayComparison([groupname, description], [oldGroupName, oldDescription])
                || arrayComparison(areaIdList2.sort(), oldAreaIdList2.sort())){
                payload = [{area_group_name: groupname, area_group_id: parseInt(groupId), area_group_description: description,
                            area_ids: areaIdList2, campus_id: dData.acnt}];
                oldPayload = [{area_group_name: oldGroupName, area_group_id: parseInt(groupId),
                               area_group_description: oldDescription, area_ids: oldAreaIdList2, campus_id: campusId}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "area_group_edit", Payload: payload,
                                    CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                    ClientId: dData.sessionId}).then(data => {
                        if (data[0]){
                            setRead(false);
                            setCount(0);
                            setAreaGroupIdList([]);
                            formSuccess("Group updated.", "editAreaGroupSubmit", "loadEditAreaGroupSubmit", "cancelEditAreaGroupBtn");
                        }
                        else{
                            formFail(`Error during save, error code: ${data[1]}`, "editAreaGroupSubmit", "loadEditAreaGroupSubmit");
                        }
                });
            }else{
                toast.info("No change")
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formAddBuildingSubmit(){
        let name, address, city, state, zip, cntry, payload;
        if (addRights){
            handleSubmitActions("addBuildingSubmit", "loadAddBuildingSubmit");
            name = document.getElementById("buildingname").value;
            address = document.getElementById("buildingaddress").value;
            city = document.getElementById("buildingcity").value;
            state = document.getElementById("buildingstate").value;
            cntry = document.getElementById("buildingcountry").value;
            zip = document.getElementById("buildingzip").value;
            payload = [{campus_id: campusId, building_name: name, street_address: address,
                        city: city, state: state, zipcode: zip, country: cntry, area_ids: areaIdList2}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "building_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setAreaGroupIdList2([]);
                    formSuccess("Building has been added.", "addBuildingSubmit", "loadAddBuildingSubmit", "cancelAddBuildingBtn", "addBuildingForm");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addBuildingSubmit", "loadAddBuildingSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditBuildingSubmit(){
        // User add form submit function
        let bId, name, address, city, state, zip, cntry, payload, oldPayload, oldName, oldAddress, oldState, oldCity,
            oldCntry, oldZip;
        if (editRights){
            handleSubmitActions("editBuildingSubmit", "loadEditBuildingSubmit");
            bId = document.getElementById("buildingIdE").value;
            name = document.getElementById("buildingnameE").value;
            address = document.getElementById("buildingaddressE").value;
            city = document.getElementById("buildingcityE").value;
            state = document.getElementById("buildingstateE").value;
            cntry = document.getElementById("buildingcountryE").value;
            zip = document.getElementById("buildingzipE").value;
            oldName = buildingActive[storedIndex]?.building_name;
            oldAddress = buildingActive[storedIndex]?.street_address;
            oldState = buildingActive[storedIndex]?.state;
            oldCity = buildingActive[storedIndex]?.city;
            oldCntry = buildingActive[storedIndex]?.country;
            oldZip = buildingActive[storedIndex]?.zipcode;
            payload = [{building_id: parseInt(bId), campus_id: campusId, building_name: name, street_address: address,
                        city: city, state: state, zipcode: zip, country: cntry, area_ids: areaIdList2}];
            oldPayload = [{building_name: oldName, street_address: oldAddress, city: oldCity, state: oldState,
                           zipcode: oldZip, country: oldCntry, area_ids: oldAreaIdList2}]
            ApiRequester({reqEndpoint: "mytransaction", TransType: "building_edit", Payload: payload,
                                OldPayload: oldPayload, CampusId: campusId, User: dData.user,
                                ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setAreaGroupIdList2([]);
                    formSuccess("Building has been updated.", "editBuildingSubmit", "loadEditBuildingSubmit", "cancelEditBuildingBtn", "editBuildingForm");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "editBuildingSubmit", "loadEditBuildingSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function removeDevicesFromAreas(areaList){
        let deviceList = [];
        for (let i=0; i < areaActive.length; i++){
            if (areaList.includes(areaActive[i].area_id)){
                if (areaActive[i]?.devices){
                    for (let i2=0; i2 < areaActive[i]?.devices.length; i2++){
                        deviceList.push(areaActive[i]?.devices[i2].device_id);
                    }
                }
            }
        }
        if (deviceList.length > 0){
            removeDevice(deviceList);
        }
    }

    function deleteAreaPerform(submitBtn, loadBtn, closeId, start, end){
        let payload, areaList = [];
        if (deleteRights){
            handleSubmitActions(submitBtn, loadBtn);
            payload = [];
            for (let i=0; i < dContent.length; i++){
                areaList.push(dContent[i][0]);
                payload.push({area_id: dContent[i][0],
                              vendor_ids: getActiveVendorIdList(),
                              });
            }
            removeDevicesFromAreas(areaList);
            ApiRequester({reqEndpoint: "mytransaction", TransType: "area_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    setCount(0);
                    setAreaIdList([]);
                    formSuccess("Areas deleted.", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteAreaBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deleteAreaGroupPerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent?.length; i++){
                payload.push({area_group_id: parseInt(dContent[i][0])});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "area_group_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    formSuccess("Groups have been deleted.", submitBtn, loadBtn, closeId);
                    setRead(false);
                    setCount(0);
                    setAreaGroupIdList([]);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteAreaGroupBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deleteBuildingPerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent?.length; i++){
                payload.push({building_id: parseInt(dContent[i][0])});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "building_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    formSuccess("Building has been deleted.", submitBtn, loadBtn, closeId);
                    setRead(false);
                    setCount(0);
                    setBuildingIdList([]);
                    document.getElementById("uCheckHead8").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBuildingBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deviceExists(serialNum){
        for (let i=0; i < deviceData.length; i++){
            if (serialNum.toString() === deviceData[i]?.manufacture_uuid.toString()) {
                return deviceData[i];
            }
        }
        return false;
    }

    function getModelId(){
        let models = [], ret = 0;
        for (let i=0; i < deviceTypeData.length; i++){
            if (deviceTypeData[i]?.inovonics_type_id === deviceTypeId){
                models = deviceTypeData[i]?.models ? deviceTypeData[i].models : [];
                break;
            }
        }
        for (let i2=0; i2 < models.length; i2++){
            if (listenPCode === models[i2].product_type_id){
                ret = models[i2].model_id;
            }
        }
        return ret;
    }

    function pendantSubmit(initial){
        let description, msg, payload, serialNum, name, areaId, dRec, nid, mId, oldPayload;
        if (devEditRights){
            if (showDeviceList){
                serialNum = listenDevice;
            }else{
                if (!serialNum || serialNum === ""){
                    serialNum = document.getElementById("serialNum").value;
                }
                if (serialNum && !isNaN(serialNum)){
                    serialNum = parseInt(serialNum);
                }
            }
            dRec = deviceExists(serialNum);
            if (initial){
                if (dRec && dRec?.is_active){
                    setAssignedArea(dRec?.area_name);
                    hideModal("pendantmodal");
                    showModal("pendantconfirmmodal");
                    return
                }else{
                    handleSubmitActions("pendantSubmit", "loadPendantSubmit");
                }
            }else{
                handleSubmitActions("pendantConfirmSubmit", "loadPendantConfirmSubmit");
            }

            if (listening){
                setListening(false);
                setListenCount(60);
            }

            name = areaActive[storedIndex]?.area_name;
            description = document.getElementById("description").value;
            areaId = document.getElementById("areaIdE").value;
            mId = modelId;
            if (!iAmHigherAuthority(80, dData?.role_weight) && showDeviceList){
                mId = getModelId(listenPCode);
            }

            if (dRec){
                // Edit device and add to area
                payload = [{device_id: dRec.device_id, campus_id: campusId, is_active: true, area_id: parseInt(areaId),
                            device_use_id: parseInt(useId), device_name: deviceTypeName, descriptions: description,
                            manufacture_model_id: parseInt(mId), modified_by: dData.user, device_type_id: deviceTypeId,
                            vendor_ids: getActiveVendorIdList(), manufacture_id: parseInt(1),
                            }];
                oldPayload = [{device_id: dRec.device_id, campus_id: dRec?.campus_id, is_active: dRec?.is_active,
                               area_id: dRec?.area_id, device_use_id: dRec?.device_use_id, manufacture_id: dRec?.manufacture_id,
                               device_name: dRec?.device_name, descriptions: dRec?.descriptions,
                               manufacture_model_id: dRec?.manufacture_model_id, device_type_id: dRec?.device_type_id}];
                if (["135", "131"].includes(useId.toString())){
                    if (["135"].includes(useId.toString())){
                        nid = document.getElementById("nid")?.value;
                        if (!nid){
                            nid = 0;
                        }
                    }else{
                        nid = -1;
                    }
                    payload[0]["network_id"] = parseInt(nid);
                    ApiRequester({reqEndpoint: "mytransaction", TransType: "system_device_edit", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                        if (data[0]) {
                            msg = `${deviceTypeName} has been added to ${name}`;
                            if (!initial){
                                setAreaIdList([]);
                                handleSubmitActions("loadPendantConfirmSubmit", "pendantConfirmSubmit");
                                handleSubmitActions("loadPendantSubmit", "pendantSubmit");
                                swapModal("pendantConfirmClose", "editareamodal");
                                toast.success(msg);
                                document.getElementById("pendantForm").reset();
                            }else{
                                formSuccess(msg, "pendantSubmit", "loadPendantSubmit",
                                "cancelPendantBtn", "pendantForm");
                            }
                            setRead(false);
                            setCount(0);
                            setListenEnabled(false);
                            setShowDeviceList(false);
                        } else {
                            toast.error(`Failed to add ${deviceTypeName}`);
                        }
                    });
                }else{
                    ApiRequester({reqEndpoint: "mytransaction", TransType: "device_assign_area", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                        if (data && data[0] === true){
                            msg = `${deviceTypeName} has been added to ${name}`;
                            if (!initial){
                                setAreaIdList([]);
                                handleSubmitActions("loadPendantConfirmSubmit", "pendantConfirmSubmit");
                                swapModal("pendantConfirmClose", "editareamodal");
                                toast.success(msg);
                                document.getElementById("pendantForm").reset();
                            }else{
                                formSuccess(msg, "pendantSubmit", "loadPendantSubmit", "cancelPendantBtn", "pendantForm");
                            }
                            setRead(false);
                            setCount(0);
                            setListenEnabled(false);
                            setShowDeviceList(false);
                        }
                        else{
                            toast.error(`Failed to add ${deviceTypeName}`);
                        }
                    });
                }
            }else{
                // Add device and add to area
                payload = [{campus_id: campusId, manufacture_id: 1, manufacture_uuid: serialNum.toString(), device_name: deviceTypeName,
                            device_use_id: parseInt(useId), is_active: true, is_alerting_now: false, is_server: false,
                            is_area_device: true, is_resident: false, area_id: parseInt(areaId), manufacture_model_id: parseInt(mId),
                            escalation_enabled: true, descriptions: description, modified_by: dData.user, device_type_id: deviceTypeId,
                            vendor_ids: getActiveVendorIdList(),
                            }];
                if (["135", "131"].includes(useId.toString())){
                    if (["135"].includes(useId.toString())){
                        nid = document.getElementById("nid")?.value;
                        if (!nid){
                            nid = 0;
                        }
                    }else{
                        nid = -1;
                    }
                    payload[0]["network_id"] = parseInt(nid);
                    ApiRequester({reqEndpoint: "mytransaction", TransType: "system_device_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                        if (data[0]) {
                            formSuccess(`${deviceTypeName} has been added to ${name}`, "pendantSubmit", "loadPendantSubmit",
                                "cancelPendantBtn", "pendantForm");
                            setRead(false);
                            setCount(0);
                            setShowDeviceList(false);
                        } else {
                            toast.error(`Failed to add ${deviceTypeName}`);
                        }
                    });
                }else{
                    ApiRequester({reqEndpoint: "mytransaction", TransType: "device_add_area", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: [],
                                ClientId: dData.sessionId}).then(data => {
                        if (data && data[0] === true){
                            formSuccess(`${deviceTypeName} has been added to ${name}`, "pendantSubmit", "loadPendantSubmit",
                                "cancelPendantBtn", "pendantForm");
                            setRead(false);
                            setCount(0);
                            setShowDeviceList(false);
                        }
                        else{
                            toast.error(`Failed to add ${deviceTypeName}`);
                        }
                    });
                }
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function publishListen(){
        let sendPtype, modelStuff;
        if (dData.serverVersion === "" || versionSort(dData.serverVersion, "4.04.14") >= 0){
            sendPtype = iAmHigherAuthority(80, dData?.role_weight) ? [productCode] : allProductCodes;
            modelStuff = iAmHigherAuthority(80, dData?.role_weight) ? `Specific ${productCode}` : "All codes";
        }else{
            sendPtype = productCode;
            modelStuff = productCode;
        }
        ApiRequester({reqEndpoint: "mqtt", Operation: "learnin", ClientId: dData.sessionId,
                            ProductType: sendPtype, CampusId: dData?.acnt, MsgClass: msgClass}).then(data => {

            if (data[0]){
                toast.info(`Listening for ${deviceTypeName} devices, Model Code: ${modelStuff}`);
                setListenCount(0);
            }
            else{
                toast.error("Error with auto listening, try again, " +
                    "if persist contact your customer success for assistance.");
                setListening(false);
                setShowDeviceList(false);
            }
        });
    }
    // Main Area Table Header
    const areaTableHead = <TableHeaders checkbox={deleteRights} headerData={areaHeaderData} checkAll={() => checkAll(ppRules.start, ppRules.end, areaIdList, setAreaIdList)}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead"} originData={areaOrigin} headerFiltersOn={true}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} modal={editRights} checkboxlist={areaIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteAreaBtn"])} modal_name={"Edit"}
                                       headerFilters={areaHeaderFilters} setHeaderFilters={setAreaHeaderFilters} setPage={setPage} />
    // Edit Area Group Area Table Header
    const areaTableHead2 = <TableHeaders checkbox={editRights} headerData={areaHeaderData2} checkAll={() => checkAll(0, areaDataCnt ? areaDataCnt : 0, areaIdList2, setAreaIdList2, "uCheckHead2", "uCheck2_")}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead2"} originData={areaOrigin} headerFiltersOn={false}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={areaIdList2}
                                       actionAppearance={() => {}} setPage={setPage} />
    // Add Area Group Area Table Header
    const areaTableHead3 = <TableHeaders checkbox={editRights} headerData={areaHeaderData2} checkAll={() => checkAll(0, areaDataCnt ? areaDataCnt : 0, areaIdList2, setAreaIdList2, "uCheckHead3", "uCheck2_")}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead3"} originData={areaOrigin} headerFiltersOn={false}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={areaIdList2}
                                       actionAppearance={() => {}} setPage={setPage} />
    // Edit Building Area Table Header
    const areaTableHead4 = <TableHeaders checkbox={editRights} headerData={areaHeaderData2} checkAll={() => checkAll(0, areaDataCnt ? areaDataCnt : 0, areaIdList2, setAreaIdList2, "uCheckHead9", "uCheck2_")}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead9"} originData={areaOrigin} headerFiltersOn={false}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={areaIdList2}
                                       actionAppearance={() => {}} setPage={setPage} />
    // Add Builidng Area Table Header
    const areaTableHead5 = <TableHeaders checkbox={editRights} headerData={areaHeaderData2} checkAll={() => checkAll(0, areaDataCnt ? areaDataCnt : 0, areaIdList2, setAreaIdList2, "uCheckHead10", "uCheck2_")}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead10"} originData={areaOrigin} headerFiltersOn={false}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} checkboxlist={areaIdList2}
                                       actionAppearance={() => {}} setPage={setPage} />

    // Main Area Group Table Header
    const areaGroupTableHead = <TableHeaders checkbox={true} headerData={groupHeaderData} checkboxlist={areaGroupIdList}
                                         checkAll={() => checkAll(ppRules2.start, ppRules2.end, areaGroupIdList, setAreaGroupIdList, "uCheckHead4", "uCheckGroup")}
                                         writeAccess={editRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead4"} modal_name={"Edit"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2} modal={editRights}
                                         actionAppearance={() => actionAppearance(ppRules2.start, ppRules2.end, ["deleteAreaGroupBtn"], "uCheckGroup")} />
    // Edit Area Area Group Table Header
    const areaGroupTableHead2 = <TableHeaders checkbox={true} headerData={groupHeaderData2} checkboxlist={areaGroupIdList2}
                                         checkAll={() => checkAll(0, groupDataCnt ? groupDataCnt : 0, areaGroupIdList2, setAreaGroupIdList2, "uCheckHead5", "uCheckGroup2_")}
                                         writeAccess={editRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead5"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                         actionAppearance={() => {}} />
    // Add Area Area Group Table Header
    const areaGroupTableHead3 = <TableHeaders checkbox={true} headerData={groupHeaderData2} checkboxlist={areaGroupIdList2}
                                         checkAll={() => checkAll(0, groupDataCnt ? groupDataCnt : 0, areaGroupIdList2, setAreaGroupIdList2, "uCheckHead6", "uCheckGroup2_")}
                                         writeAccess={editRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead6"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                         actionAppearance={() => {}} />
    // Add Area Bulk Area Group Table Header
    const areaGroupTableHead4 = <TableHeaders checkbox={true} headerData={groupHeaderData2} checkboxlist={areaGroupIdList2}
                                         checkAll={() => checkAll(0, groupDataCnt ? groupDataCnt : 0, areaGroupIdList2, setAreaGroupIdList2, "uCheckHead7", "uCheckGroup2_")}
                                         writeAccess={editRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead7"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2}
                                         actionAppearance={() => {}} />

    // Main Building Table Header
    const buildingTableHead = <TableHeaders checkbox={true} headerData={buildingHeaderData} checkboxlist={buildingIdList}
                                            checkAll={() => checkAll(ppRules3.start, ppRules3.end, buildingIdList, setBuildingIdList, "uCheckHead8", "uCheckBuilding")}
                                            writeAccess={editRights} sortOrder={sorter3.sortOrder} checkboxHeaderId={"uCheckHead8"} modal_name={"Edit"}
                                            sortColumn={sorter3.sortColumn} sorter={sorter3} setSorter={setSorter3} modal={editRights} originData={buildingOrigin} headerFiltersOn={true}
                                            headerFilters={buildingHeaderFilters} setHeaderFilters={setBuildingHeaderFilters} setPage={setPage}
                                            actionAppearance={() => actionAppearance(ppRules3.start, ppRules3.end, ["deleteBuildingBtn"], "uCheckBuilding")} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                {deleteRights
                    ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                 id={"deleteAreaBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                 onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, areaActive,
                                     "area_name", ["area_id", ""], "", setDContent,
                                     "Are you sure you want to delete the following areas? \n",
                                     "bulkdeleteareamodal", "deleteBulkAreaModalContent")} />
                    :   <></>
                }
                {deleteRights
                    ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                 id={"deleteAreaGroupBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                 onClick={() => bulkDeleteModal(ppRules2.start, ppRules2.end, areaGroupActive,
                                     "area_group_name", ["area_group_id", ""], "", setDContent,
                                     "Are you sure you want to delete the following areas? \n",
                                     "bulkdeleteareagroupmodal", "deleteBulkAreaGroupModalContent", "uCheckGroup")} />
                    :   <></>
                }
                {deleteRights
                    ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                 id={"deleteBuildingBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                 onClick={() => bulkDeleteModal(ppRules3.start, ppRules3.end, buildingActive,
                                     "building_name", ["building_id", ""], "", setDContent,
                                     "Are you sure you want to delete the following areas? \n",
                                     "bulkdeletebuildingmodal", "deleteBulkBuildingModalContent", "uCheckBuilding")} />
                    :   <></>
                }
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                            style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
                {addRights && tabItem === "areas" && areasLoaded
                    ?   <Button text={"New Area"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                 icon={true} iconClass={"fe fe-plus me-2"}
                                 onClick={() => {
                                     setAreaGroupIdList([]);
                                     setSearch2("");
                                     document.getElementById("name").value = "";
                                     document.getElementById("name-bulk").value = "";
                                     document.getElementById("add-start-bulk").value = 1;
                                     document.getElementById("add-end-bulk").value = 10;
                                     document.getElementById("livingcap").value = 2;
                                     document.getElementById("livingcap-bulk").value = 2;
                                     document.getElementById("uCheckHead3").checked = false;
                                     document.getElementById("add-start-preview").value = "1";
                                     document.getElementById("add-end-preview").value = "10";
                                     setStoredIndex(undefined);
                                     setShowChecked(false);
                                     showModal("addareamodal");
                                     setAddTabItem("single");
                                     formCheck("addAreaForm", "addAreaSubmit")}} />
                    :   <></>
                }
                {addRights && tabItem === "areagroups" && areaGroupLoaded
                    ?   <Button text={"New Group"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                 icon={true} iconClass={"fe fe-plus me-2"}
                                 onClick={() => {
                                     setSearch("");
                                     setAreaIdList2([]);
                                     document.getElementById("uCheckHead6").checked = false;
                                     setStoredIndex(undefined);
                                     setShowChecked(false);
                                     showModal("addareagroupmodal");
                                     formCheck("addAreaGroupForm", "addAreaGroupSubmit");}} />
                    :   <></>
                }
                {addRights && tabItem === "buildings" && buildingLoaded
                    ?   <Button text={"New Building"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                 icon={true} iconClass={"fe fe-plus me-2"}
                                 onClick={() => {
                                     setStoredIndex(undefined);
                                     setShowChecked(false);
                                     setAreaIdList2([]);
                                     setOldAreaIdList2([]);
                                     showModal("addbuildingmodal");
                                     formCheck("addBuildingForm", "addBuildingSubmit");}} />
                    :   <></>
                }
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)}
                            pageAction={() => {
                                setAreaDataLoaded(false);
                                setAreaGroupDataLoaded(false);
                                setBuildingDataLoaded(false);
                                setAreaTypesLoaded(false);
                                setDevicesLoaded(false);
                                setDevCatLoaded(false);
                                setDevTypeLoaded(false);
                                setAreasLoaded(false);
                                setAreaGroupLoaded(false);
                                setBuildingLoaded(false);
                            }}/>
        </div>
    );

    const footer = (
        <>
            {tabItem === "areas"
                ?   <div>
                    <Pagination>
                        <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                         endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                         max={ppRules.max}/>
                    </Pagination>
                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
                </div>
                :   <></>
            }
            {tabItem === "areagroups"
                ?   <div>
                    <Pagination>
                        <PaginationItems setPage={setPage2} page={page2} beginDot={ppRules2.beginDot}
                                         endDot={ppRules2.endDot} pageMin={ppRules2.pageMin} pageMax={ppRules2.pageMax}
                                         max={ppRules2.max}/>
                    </Pagination>
                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
                </div>
                :   <></>
            }
            {tabItem === "buildings"
                ?   <div>
                    <Pagination>
                        <PaginationItems setPage={setPage3} page={page3} beginDot={ppRules3.beginDot}
                                         endDot={ppRules3.endDot} pageMin={ppRules3.pageMin} pageMax={ppRules3.pageMax}
                                         max={ppRules3.max}/>
                    </Pagination>
                    <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
                </div>
                :   <></>
            }
        </>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Community"} Title={"Areas"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                        <li className={"nav-item"}>
                             <Button text={"Areas"}  spinner={!areasLoaded}
                                     class={tabItem === "areas" ? "nav-link active" : "nav-link"}
                                     onClick={() => setTabItem("areas")}/>
                        </li>
                        <li className={"nav-item"}>
                            <Button text={"Area Groups"}  spinner={!areaGroupLoaded}
                                     class={tabItem === "areagroups" ? "nav-link active" : "nav-link"}
                                     onClick={() => setTabItem("areagroups")}/>
                        </li>
                        <li className={"nav-item"}>
                            <Button text={"Buildings"}  spinner={!buildingLoaded}
                                     class={tabItem === "buildings" ? "nav-link active" : "nav-link"}
                                     onClick={() => setTabItem("buildings")}/>
                        </li>
                    </ul>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <TableSkeleton />
                    </div>
                    <div className={tabItem === "areas" ? "d-block" : "d-none"}>
                        <div className={"d-flex justify-content-end mb-2"}>
                            <span className={"text-muted"} style={{fontSize: "0.9rem"}}>
                                Showing <strong>{Math.min(ppRules.start+1, areaOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, areaOrigin.length)}</strong> of <strong>{areaOrigin.length}</strong> {areaOrigin.length === 1 ? "area" : "areas"}
                            </span>
                        </div>
                        <table className={"table table-sm table-white table-hover"}>
                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                {areaTableHead}
                            </thead>
                            <tbody id={"tBody"}>
                                {areaTableRows}
                            </tbody>
                        </table>
                    </div>
                    <div className={tabItem === "areagroups" ? "d-block" : "d-none"}>
                        <div className={"d-flex justify-content-end mb-2"}>
                            <span className={"text-muted"} style={{fontSize: "0.9rem"}}>
                                Showing <strong>{Math.min(ppRules.start+1, areaGroupOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, areaGroupOrigin.length)}</strong> of <strong>{areaGroupOrigin.length}</strong> {areaGroupOrigin.length === 1 ? "group" : "groups"}
                            </span>
                        </div>
                        <table className={"table table-sm table-white table-hover"}>
                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                {areaGroupTableHead}
                            </thead>
                            <tbody id={"tBody"}>
                                {groupTableRows}
                            </tbody>
                        </table>
                    </div>
                    <div className={tabItem === "buildings" ? "d-block" : "d-none"}>
                        <div className={"d-flex justify-content-end mb-2"}>
                            <span className={"text-muted"} style={{fontSize: "0.9rem"}}>
                                Showing <strong>{Math.min(ppRules.start+1, buildingOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, buildingOrigin.length)}</strong> of <strong>{buildingOrigin.length}</strong> {buildingOrigin.length === 1 ? "building" : "buildings"}
                            </span>
                        </div>
                        <table className={"table table-sm table-white table-hover"}>
                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                {buildingTableHead}
                            </thead>
                            <tbody id={"tBody"}>
                                {buildingTableRows}
                            </tbody>
                        </table>
                    </div>
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer}/>
            </div>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade"} id={"addareamodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Area</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        {iAmHigherAuthority(80, dData.role_weight)
                            ?   <ul className={"nav nav-tabs nav-overflow header-tabs"} style={{display: "flex", borderBottom: "2px solid #dee2e6"}}>
                                    <li key={"set-single"} className={"nav-item"} style={{flex: "1", textAlign: "center"}}>
                                        <Button text={"Single Add"}
                                                class={addTabItem === "single" ? "nav-link active" : "nav-link"}
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "0",
                                                    border: "none",
                                                    borderBottom: addTabItem === "single" ? "3px solid #007bff" : "3px solid transparent",
                                                    backgroundColor: addTabItem === "single" ? "transparent" : "transparent",
                                                    color: addTabItem === "single" ? "#007bff" : "#6c757d",
                                                    fontWeight: addTabItem === "single" ? "600" : "400",
                                                    transition: "all 0.2s ease-in-out",
                                                    padding: "0.75rem 1rem",
                                                    marginBottom: "-2px"
                                                }}
                                                onClick={() => {
                                                    setAddTabItem("single");
                                                }}/>
                                    </li>
                                    <li key={"set-bulk"} className={"nav-item"} style={{flex: "1", textAlign: "center"}}>
                                        <Button text={"Bulk Add"}
                                                class={addTabItem === "bulk" ? "nav-link active" : "nav-link"}
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "0",
                                                    border: "none",
                                                    borderBottom: addTabItem === "bulk" ? "3px solid #007bff" : "3px solid transparent",
                                                    backgroundColor: addTabItem === "bulk" ? "transparent" : "transparent",
                                                    color: addTabItem === "bulk" ? "#007bff" : "#6c757d",
                                                    fontWeight: addTabItem === "bulk" ? "600" : "400",
                                                    transition: "all 0.2s ease-in-out",
                                                    padding: "0.75rem 1rem",
                                                    marginBottom: "-2px"
                                                }}
                                                onClick={() => setAddTabItem("bulk")}/>
                                    </li>
                                </ul>
                            :   <></>
                        }
                        <form id={"addBulkForm"} className={`was-validated ${addTabItem === "single" ? "d-none" : ""}`}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"name-bulk"}
                                           onKeyUp={() => {
                                               document.getElementById("add-start-preview").value = `${document.getElementById("name-bulk").value}${document.getElementById("add-start-bulk").value}`;
                                               document.getElementById("add-end-preview").value = `${document.getElementById("name-bulk").value}${document.getElementById("add-end-bulk").value}`;
                                               formCheck("addBulkForm", "addBulkSubmit");
                                           }}
                                           required={false} pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                    <label htmlFor={"name-bulk"}>Prefix Name</label>
                                </div>
                                <p className={"text-info mb-2"}>* A maximum of 500 rooms may be added at a time.</p>
                                <div className={"d-flex justify-content-between"}>
                                    <div className={"form-floating mb-3 w-50 me-4"}>
                                        <input type={"number"} className={"form-control"} id={"add-start-bulk"}
                                               onKeyUp={() => formCheck("addBulkForm", "addBulkSubmit")}
                                               required={true} step={1} min={1} max={99998}
                                               onChange={(e) => {
                                                   document.getElementById("add-end-bulk").min = parseInt(e.target.value) + 1;
                                                   if (parseInt(document.getElementById("add-end-bulk").value) <= parseInt(e.target.value)) {
                                                       document.getElementById("add-end-bulk").value = parseInt(e.target.value) + 1;
                                                   }
                                                   document.getElementById("add-start-preview").value = `${document.getElementById("name-bulk").value}${document.getElementById("add-start-bulk").value}`;
                                                   document.getElementById("add-end-preview").value = `${document.getElementById("name-bulk").value}${document.getElementById("add-end-bulk").value}`;
                                               }}/>
                                        <label htmlFor={"add-start-bulk"}>Start Number</label>
                                        <div className={"invalid-feedback"}>
                                            Invalid start number, must be less than end number between 1 - 99999
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3 w-50 ms-4"}>
                                        <input type={"number"} className={"form-control"} id={"add-end-bulk"}
                                               onKeyUp={() => formCheck("addBulkForm", "addBulkSubmit")}
                                               required={true} step={1} min={2} max={99999} onChange={(e) => {
                                                   if (parseInt(document.getElementById("add-start-bulk").value) >= parseInt(e.target.value)) {
                                                       document.getElementById("add-start-bulk").value = parseInt(e.target.value) - 1;
                                                   }
                                                   document.getElementById("add-start-preview").value = `${document.getElementById("name-bulk").value}${document.getElementById("add-start-bulk").value}`;
                                                   document.getElementById("add-end-preview").value = `${document.getElementById("name-bulk").value}${document.getElementById("add-end-bulk").value}`;
                                               }}/>
                                        <label htmlFor={"add-end-bulk"}>End Number</label>
                                        <div className={"invalid-feedback"}>
                                            Invalid end number, must be less than end number between 1 - 99999
                                        </div>
                                    </div>
                                </div>
                                <div className={"d-flex justify-content-between"}>
                                    <div className={"form-floating mb-3 w-50 me-4"}>
                                        <input type={"text"} className={"form-control"} id={"add-start-preview"}
                                               required={false} readOnly={true} />
                                        <label htmlFor={"add-start-preview"}>Start Preview</label>
                                    </div>
                                    <div className={"form-floating mb-3 w-50 ms-4"}>
                                        <input type={"text"} className={"form-control"} id={"add-end-preview"}
                                               required={false} readOnly={true} />
                                        <label htmlFor={"add-end-preview"}>End Preview</label>
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"areaType-bulk"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                if (![1,2,3,4,15].includes(parseInt(e.target.value))){
                                                    document.getElementById("livingcap-bulk").value = 0;
                                                }
                                                formCheck("addBulkForm", "addBulkSubmit");
                                            }}>
                                        <option value={""}></option>
                                        {areaDd}
                                    </select>
                                    <label htmlFor={"areaType-bulk"}>Area Type</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"building-bulk"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                formCheck("addBulkForm", "addBulkSubmit");
                                            }}>
                                        <option value={"0"} disabled={buildingOptions.length > 0}>Main (Campus Default)</option>
                                        {buildingOptions}
                                    </select>
                                    <label htmlFor={"building-bulk"}>Building</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"number"} className={"form-control"} id={"livingcap-bulk"} required={true}
                                           onKeyUp={() => formCheck("addBulkForm", "addBulkSubmit")}
                                           step={1} min={0} max={4} title={"Limits number of residents assigned to area."} />
                                    <label htmlFor={"livingcap-bulk"}>Max Occupancy</label>
                                    <div className={"invalid-feedback"}>
                                        0-4 Max. Best practice is to set 0 for common areas.
                                    </div>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Groups</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2-bulk"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover d-sm-table"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaGroupTableHead4}
                                            </thead>
                                            <tbody>
                                                {groupTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddBulkBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true} text={"Loading"} id={"loadAddBulkSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"} onClick={() => formAddBulkSubmit()} id={"addBulkSubmit"}>Submit</button>
                            </div>
                        </form>
                        <form id={"addAreaForm"} className={`was-validated ${addTabItem === "bulk" ? "d-none" : ""}`}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"name"}
                                           onKeyUp={() => formCheck("addAreaForm", "addAreaSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                    <label htmlFor={"name"}>Name</label>
                                    <div className={"invalid-feedback"}>
                                        Valid room name required
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"areaType"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                if (![1,2,3,4,15].includes(parseInt(e.target.value))){
                                                    document.getElementById("livingcap").value = 0;
                                                }
                                                formCheck("addAreaForm", "addAreaSubmit");
                                            }}>
                                        <option value={""}></option>
                                        {areaDd}
                                    </select>
                                    <label htmlFor={"areaType"}>Area Type</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"building"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                formCheck("addAreaForm", "addAreaSubmit");
                                            }}>
                                        <option value={"0"} disabled={buildingOptions.length > 0}>Main (Campus Default)</option>
                                        {buildingOptions}
                                    </select>
                                    <label htmlFor={"building"}>Building</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"number"} className={"form-control"} id={"livingcap"} required={true}
                                           onKeyUp={() => formCheck("addAreaForm", "addAreaSubmit")}
                                           step={1} min={0} max={4} title={"Limits number of residents assigned to area."} />
                                    <label htmlFor={"livingcap"}>Max Occupancy</label>
                                    <div className={"invalid-feedback"}>
                                        0-4 Max. Best practice is to set 0 for common areas.
                                    </div>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Groups</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"areagroup-add-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "#c1c1c1"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"areagroup-add-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover d-sm-table"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaGroupTableHead3}
                                            </thead>
                                            <tbody>
                                                {groupTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddAreaBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true} text={"Loading"} id={"loadAddAreaSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"} onClick={() => formAddAreaSubmit()} id={"addAreaSubmit"}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editareamodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>Edit Area</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"editAreaForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"w-50 d-inline-block"}>
                                    <input type={"hidden"} id={"areaIdE"} />
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"nameE"}
                                               onKeyUp={() => formCheck("editAreaForm", "editAreaSubmit")} required={true}
                                               pattern={"^[0-9a-zA-Z_\\- ]+"}/>
                                        <label htmlFor={"nameE"}>Name</label>
                                        <div className={"invalid-feedback"}>
                                            Please enter a name!
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <select className={"form-select"} id={"areaTypeE"} required={true}
                                                onChange={() => {
                                                formCheck("editAreaForm", "editAreaSubmit");
                                            }}>
                                            <option value={""}></option>
                                            {areaDd}
                                        </select>
                                        <label htmlFor={"areaTypeE"}>Area Type</label>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <select className={"form-select"} id={"buildingE"} defaultValue={undefined}
                                                required={true} onChange={(e) => {
                                                    formCheck("editAreaForm", "editAreaSubmit");
                                                }}>
                                            <option value={"0"} disabled={buildingOptions.length > 0}>Main (Campus Default)</option>
                                            {buildingOptions}
                                        </select>
                                        <label htmlFor={"buildingE"}>Building</label>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"number"} className={"form-control"} id={"livingcapE"}
                                               onKeyUp={() => formCheck("editAreaForm", "editAreaSubmit")}
                                               step={1} min={0} max={100} />
                                        <label htmlFor={"livingcapE"}>Max Occupancy</label>
                                        <div className={"invalid-feedback"}>
                                            Enter capacity from 0 - 100!
                                        </div>
                                    </div>
                                </div>
                                <div className={"w-50 d-inline-block align-top"} style={{paddingLeft: ".5em"}}>
                                    <div className={"modal-header px-1 pt-0 pb-3"}>
                                        <h2 className={"d-inline my-0 ms-2"}>Devices</h2>
                                        {editRights
                                            ?   <Button text={"Device"} type={"button"} class={"btn btn-primary ms-3"}
                                                         id={"pendantBtn"} icon={true} iconClass={"fe fe-plus me-2"}
                                                         onClick={() => {
                                                             document.getElementById("content-heading-container")?.classList?.add("d-none");
                                                             document.getElementById("alarm-heading-container")?.classList?.add("d-none");
                                                             setDeviceTypeId(0);
                                                             setDeviceCatId(0);
                                                             setListening(false);
                                                             setListenDevice("");
                                                             setListenData([]);
                                                             setListenList([]);
                                                             setShowDeviceList(false);
                                                             swapModal("cancelEditAreaBtn", "pendantmodal")
                                                     }} />
                                            :   <></>
                                        }
                                    </div>
                                    <div className={"modal-body px-1 py-3"}>
                                        <h4>Community Devices</h4>
                                        <table>
                                            <tbody>
                                                {editDeviceList}
                                            </tbody>
                                        </table>
                                    </div>
                                    {iAmHigherAuthority(80, dData?.role_weight) && editSystemDeviceList.length > 0
                                        ? <div className={"modal-body px-1 py-3"}>
                                            <h4>System Devices</h4>
                                            <table>
                                                <tbody>
                                                    {editSystemDeviceList}
                                                </tbody>
                                            </table>
                                         </div>
                                        :  <></>
                                    }
                                </div>
                                <hr/>
                                <div className={"mt-1"}>
                                    <h3>Groups</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2E"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} id={"search2EBtn"} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"areagroup-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "#c1c1c1"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"areagroup-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover d-sm-table"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaGroupTableHead2}
                                            </thead>
                                            <tbody>
                                                {groupTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    {deleteRights
                                        ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger me-3"}
                                                     id={"deleteSingleAreaBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"} />
                                        :   <></>
                                    }
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditAreaBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadEditAreaSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => formEditAreaSubmit()} id={"editAreaSubmit"}>Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"pendantmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticDeviceBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticDeviceBackdropLabel"}>Add Device</h2>
                            <button type={"button"} className={"btn-close"} id={"pendantClose"} data-bs-dismiss={"modal"} aria-label={"Close"}
                                    onClick={() => setListening(false)}/>
                        </div>
                        <form id={"pendantForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3 d-inline-block me-2"} style={{width: "68%"}}>
                                    <select className={"form-select"} value={undefined}
                                            required={true} id={"device_category"}
                                            onChange={(e) => {
                                                setDeviceCatId(parseInt(e.target.value));
                                                setDeviceTypeId(0);
                                                setModelId(0);
                                                formCheck("pendantForm", "pendantSubmit");
                                            }}>
                                        <option value={""}></option>
                                        {deviceCatOptions}
                                    </select>
                                    <label htmlFor={"device_category"}>Device Category</label>
                                </div>
                                <div className={"d-flex justify-content-start"}>
                                    <div className={"form-floating mb-3 d-inline-block me-2"} style={{width: "68%"}}>
                                        <select className={"form-select"} value={undefined}
                                                required={true} id={"device_type_id"}
                                                onChange={(e) => {
                                                    setDeviceTypeId(parseInt(e.target.value));
                                                    setDeviceTypeName(e.target[e.target.selectedIndex].innerText);
                                                    areaLearninBehaviorToggle(e.target.value);
                                                    formCheck("pendantForm", "pendantSubmit");
                                                }}>
                                            <option value={""}></option>
                                            {deviceTypeOptions}
                                        </select>
                                        <label htmlFor={"device_type_id"}>Device Type</label>
                                        <div className={deviceImg ? "select-img-div" : "select-img-div-nohover"}>
                                            {deviceImg
                                                ?   <img src={`/static/image/${deviceImg}`}
                                                        alt={""}
                                                        className={"mx-auto"}
                                                        style={{width: "inherit", height: "inherit", padding: "0 10px 6px 0"}}/>
                                                :   <></>
                                            }
                                        </div>
                                    </div>
                                    <div className={"form-floating mb-3 d-inline-block ms-auto"} style={{width: "30%"}}>
                                        <select className={"form-select"} id={"modelId"} value={modelId}
                                                onChange={(e) => {
                                                    setModelId(parseInt(e.target.value));
                                                    formCheck("pendantForm", "pendantSubmit");
                                                }}>
                                            {modelOptions}
                                        </select>
                                        <label htmlFor={"modelId"}>Model</label>
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"description"}
                                           pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                    <label htmlFor={"description"}>Description (optional)</label>
                                </div>
                                <div className={"d-flex justify-content-start"}>
                                    <div className={`form-floating mb-3 w-75 ${showDeviceList && "d-none"}`}
                                         id={"serialToggle"}>
                                        <input type={"text"} className={"form-control"} id={"serialNum"}
                                               required={!showDeviceList}
                                               onKeyUp={(e) => formCheckWithElement("pendantForm", "pendantSubmit", e, deviceData)}
                                               pattern={"^[0-9]+$"}/>
                                        <label htmlFor={"serialNum"}>Serial Number</label>
                                    </div>
                                    <div className={`form-floating mb-3 w-75 ${!showDeviceList && "d-none"}`}
                                         id={"serial2Toggle"}>
                                        <select className={"form-select"} id={"serialNum2"} required={showDeviceList}
                                                onClick={(e) => {
                                                    let tmp = e.target.value.split(",");
                                                    setListenDevice(tmp[0]);
                                                    setListenPCode(parseInt(tmp[1]));
                                                }}>
                                            {listenList}
                                        </select>
                                        <label htmlFor={"serialNum2"}>Serial Numbers</label>
                                    </div>
                                    <Button text={"Auto Listen"} id={"listen-btn-1"}
                                            class={`btn ${listenEnabled ? "btn-primary" : "btn-danger"} m-auto ${showDeviceList && "d-none"}`}
                                            disabled={!listenEnabled} onClick={() => {
                                        setListening(true);
                                        setListenDevice("");
                                        setShowDeviceList(true);
                                        publishListen()
                                    }}/>
                                    <Button text={"Stop Listen"} id={"listen-btn-2"}
                                            class={`btn ${listening ? "btn-success" : "btn-warning"} m-auto ${!showDeviceList && "d-none"}`}
                                            disabled={!listenEnabled} onClick={() => {
                                        setListening(false);
                                        setShowDeviceList(false);
                                    }}/>
                                </div>
                                <div id={"ncsettings"} className={"d-none"}>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"number"} className={"form-control"} id={"nid"}
                                               required={false} min={0} max={31} step={1} onChange={() => {
                                            formCheck("pendantForm", "pendantSubmit");
                                        }}/>
                                        <label htmlFor={"serialNum"}>Network ID</label>
                                        <div className={"invalid-feedback"}>
                                            Please enter a valid network id for coordinator. Valid 0 - 31
                                        </div>
                                    </div>
                                </div>
                                <div className={`list-group-item ${!showAlarmBehaviors && 'd-none'}`}
                                     id={"behavior-heading-container"}>
                                    <h4 className={"mb-4 text-center"}>Alarm Behavior</h4>
                                    {useOptions}
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelPendantBtn"}
                                            onClick={() => {
                                                swapModal("pendantClose", "editareamodal");
                                                formClear("pendantForm", "pendantSubmit");
                                                setListening(false);
                                            }}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadPendantSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} id={"pendantSubmit"}
                                            onClick={() => {
                                                pendantSubmit(true);
                                            }}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"pendantconfirmmodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticPendantConfirmLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticPendantConfirmLabel"}>Confirm Add</h2>
                            <button type={"button"} className={"btn-close"} id={"pendantConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <p>Device is already linked to {assignedArea} Do you wish to re-assign this device?</p>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}}
                                    id={"pendantConfirmCancelBtn"}
                                    onClick={() => swapModal("pendantConfirmClose", "pendantmodal")}>No
                            </button>
                            <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true}
                                    text={"Loading"} id={"loadPendantConfirmSubmit"}/>
                            <button type={"button"} className={"btn btn-primary ms-3"} id={"pendantConfirmSubmit"}
                                    onClick={() => pendantSubmit(false)}>YES
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addareagroupmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Group</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"addAreaGroupForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"groupname"}
                                           onKeyUp={() => formCheck("addAreaGroupForm", "addAreaGroupSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"groupname"}>Group</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a valid group name.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"description"}
                                           onKeyUp={() => formCheck("addAreaGroupForm", "addAreaGroupSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <label htmlFor={"description"}>Description</label>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Areas</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} id={"search2Btn"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"area-add-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "#c1c1c1"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"area-add-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaTableHead3}
                                            </thead>
                                            <tbody>
                                                {areaTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddAreaGroupBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadAddAreaGroupSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"}
                                        onClick={() => formAddAreaGroupSubmit()} id={"addAreaGroupSubmit"}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editareagroupmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Group</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"editAreaGroupForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <input type={"hidden"} id={"groupIdE"} />
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"groupNameE"}
                                           onKeyUp={() => formCheck("editAreaGroupForm", "editAreaGroupSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"groupNameE"}>Group</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a group name!
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"descriptionE"}
                                           onKeyUp={() => formCheck("editAreaGroupForm", "editAreaGroupSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <label htmlFor={"descriptionE"}>Description</label>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Areas</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2E"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""}  id={"search2EBtn2"} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"area-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "#c1c1c1"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"area-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaTableHead2}
                                            </thead>
                                            <tbody>
                                                {areaTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    {deleteRights
                                        ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger me-3"}
                                                     id={"deleteSingleAreaGroupBtn"} icon={true}
                                                     iconClass={"fe fe-trash-2 me-2"}/>
                                        :   <></>
                                    }
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditAreaGroupBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadEditAreaGroupSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => formEditAreaGroupSubmit()} id={"editAreaGroupSubmit"}>Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addbuildingmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Building</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"addBuildingForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"buildingname"}
                                           onKeyUp={() => formCheck("addBuildingForm", "addBuildingSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"buildingname"}>Building Name</label>
                                    <div className={"invalid-feedback"}>
                                        Referencable name required.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"buildingcountry"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                setCountryOptionsFunction(e.target.value);
                                                formCheck("addBuildingForm", "addBuildingSubmit");
                                        }} >
                                        <option value={""}></option>
                                        {countryOptions}
                                    </select>
                                    <label htmlFor={"buildingcountry"}>Country</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"buildingstate"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                formCheck("addBuildingForm", "addBuildingSubmit");
                                            }}>
                                        <option value={"buildingstate"}></option>
                                        {stateOptions}
                                    </select>
                                    <label htmlFor={"buildingstate"}>State</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"buildingaddress"}
                                           onKeyUp={() => formCheck("addBuildingForm", "addBuildingSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_\\- ]+$"} />
                                    <label htmlFor={"buildingaddress"}>Street Address</label>
                                </div>
                                <div className={"d-flex justify-content-around"}>
                                    <div className={"form-floating mb-3 w-50 me-2"}>
                                        <input type={"text"} className={"form-control"} id={"buildingcity"}
                                               onKeyUp={() => formCheck("addBuildingForm", "addBuildingSubmit")}
                                               required={true} pattern={"^[0-9a-zA-Z_\\- ]+$"} />
                                        <label htmlFor={"buildingcity"}>City</label>
                                    </div>
                                    <div className={"form-floating mb-3 w-50 ms-2"}>
                                        <input type={"text"} className={"form-control"} id={"buildingzip"}
                                               onKeyUp={() => formCheck("addBuildingForm", "addBuildingSubmit")}
                                               required={true} pattern={zipReg} />
                                        <label htmlFor={"buildingzip"}>Zipcode</label>
                                    </div>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Areas</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"area-b-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "#c1c1c1"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"area-b-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaTableHead5}
                                            </thead>
                                            <tbody>
                                                {areaTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddBuildingBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadAddBuildingSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"}
                                        onClick={() => formAddBuildingSubmit()} id={"addBuildingSubmit"}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editbuildingmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Building</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"editBuildingForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <input type={"hidden"} id={"buildingIdE"} />
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"buildingnameE"}
                                           onKeyUp={() => formCheck("editBuildingForm", "editBuildingSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"buildingnameE"}>Building Name</label>
                                    <div className={"invalid-feedback"}>
                                        Referencable name required.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"buildingcountryE"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                setCountryOptionsFunction(e.target.value);
                                                formCheck("editBuildingForm", "editBuildingSubmit");
                                        }} >
                                        <option value={""}></option>
                                        {countryOptions}
                                    </select>
                                    <label htmlFor={"buildingcountryE"}>Country</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"buildingstateE"} defaultValue={undefined}
                                            required={true} onChange={(e) => {
                                                if (![1,2,3,4,15].includes(parseInt(e.target.value))){
                                                    document.getElementById("buildingstateE").value = 0;
                                                }
                                                formCheck("editBuildingForm", "editBuildingSubmit");
                                            }}>
                                        <option value={"buildingstateE"}></option>
                                        {stateOptions}
                                    </select>
                                    <label htmlFor={"buildingstateE"}>State</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"buildingaddressE"}
                                           onKeyUp={() => formCheck("editBuildingForm", "editBuildingSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_\\- ]+$"} />
                                    <label htmlFor={"buildingaddressE"}>Street Address</label>
                                </div>
                                <div className={"d-flex justify-content-around"}>
                                    <div className={"form-floating mb-3 w-50 me-2"}>
                                        <input type={"text"} className={"form-control"} id={"buildingcityE"}
                                               onKeyUp={() => formCheck("editBuildingForm", "editBuildingSubmit")}
                                                pattern={"^[0-9a-zA-Z_\\- ]+$"} />
                                        <label htmlFor={"buildingcityE"}>City</label>
                                    </div>
                                    <div className={"form-floating mb-3 w-50 ms-2"}>
                                        <input type={"text"} className={"form-control"} id={"buildingzipE"}
                                               onKeyUp={() => formCheck("editBuildingForm", "editBuildingSubmit")}
                                               required={true} pattern={zipReg} />
                                        <label htmlFor={"buildingzipE"}>Zipcode</label>
                                    </div>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Areas</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2E"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div className={"form-check d-inline-block ms-5 mb-3"}>
                                        <input className={"form-check-input form-check-med"} id={"area-add-b-show"}
                                               style={{borderWidth: "1px", borderStyle: "solid", borderColor: "#c1c1c1"}}
                                               type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                   setShowChecked(e.target.checked);
                                        }} />
                                        <label className={"form-check-label text-dark"} htmlFor={"area-add-b-show"}>Show selected only</label>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaTableHead4}
                                            </thead>
                                            <tbody>
                                                {areaTableRows2}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    {deleteRights
                                        ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger me-3"}
                                                     id={"deleteSingleBuildingBtn"} icon={true}
                                                     iconClass={"fe fe-trash-2 me-2"}/>
                                        :   <></>
                                    }
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditBuildingBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadEditBuildingSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => formEditBuildingSubmit()} id={"editBuildingSubmit"}>Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <SingleDeleteModal closeBtn={"confirmAreaClose"} cancelBtn={"cancelDeleteAreaBtn"} modal_name={"editareamodal"} loadBtn={"loadDeleteAreaSubmit"}
                               submitBtn={"deleteAreaSubmit"} modalContent={"deleteAreaModalContent"}
                deletePerform={() => deleteAreaPerform("deleteAreaSubmit", "loadDeleteAreaSubmit", "confirmAreaClose", ppRules.start, ppRules.end)}
                header={"Delete Area"}/>
            <SingleDeleteModal closeBtn={"confirmAreaGroupClose"} cancelBtn={"cancelDeleteAreaGroupBtn"} modal_name={"editareagroupmodal"} loadBtn={"loadDeleteAreaGroupSubmit"}
                               submitBtn={"deleteAreaGroupSubmit"} modalContent={"deleteAreaGroupModalContent"}
                deletePerform={() => deleteAreaGroupPerform("deleteAreaGroupSubmit", "loadDeleteAreaGroupSubmit", "confirmAreaGroupClose", ppRules2.start, ppRules2.end)}
                header={"Delete Area Group"}/>
            <SingleDeleteModal closeBtn={"confirmBuildingClose"} cancelBtn={"cancelDeleteBuildingBtn"} modal_name={"editbuildingmodal"} loadBtn={"loadDeleteBuildingSubmit"}
                               submitBtn={"deleteBuildingSubmit"} modalContent={"deleteBuildingModalContent"}
                deletePerform={() => deleteBuildingPerform("deleteBuildingSubmit", "loadDeleteBuildingSubmit", "confirmBuildingClose", ppRules3.start, ppRules3.end)}
                header={"Delete Building"}/>
            <BulkDeleteModal closeBtn={"bulkConfirmAreaClose"} cancelBtn={"bulkCancelDeleteAreaBtn"} loadBtn={"loadBulkDeleteAreaSubmit"}
                             submitBtn={"bulkDeleteAreaSubmit"} modalContent={"deleteBulkAreaModalContent"} modalName={"bulkdeleteareamodal"}
                deletePerform={() => deleteAreaPerform("bulkDeleteAreaSubmit", "loadBulkDeleteAreaSubmit", "bulkConfirmAreaClose", ppRules.start, ppRules.end)}
                start={ppRules.start} end={ppRules.end} header={"Delete Areas"}/>
            <BulkDeleteModal closeBtn={"bulkConfirmAreaGroupClose"} cancelBtn={"bulkCancelDeleteAreaGroupBtn"} loadBtn={"loadBulkDeleteAreaGroupSubmit"}
                             submitBtn={"bulkDeleteAreaGroupSubmit"} modalContent={"deleteBulkAreaGroupModalContent"} modalName={"bulkdeleteareagroupmodal"}
                deletePerform={() => deleteAreaGroupPerform("bulkDeleteAreaGroupSubmit", "loadBulkDeleteAreaGroupSubmit", "bulkConfirmAreaGroupClose", ppRules2.start, ppRules2.end)}
                start={ppRules2.start} end={ppRules2.end} header={"Delete Area Groups"}/>
            <BulkDeleteModal closeBtn={"bulkConfirmBuildingClose"} cancelBtn={"bulkCancelDeleteBuildingBtn"} loadBtn={"loadBulkDeleteBuildingSubmit"}
                             submitBtn={"bulkDeleteBuildingSubmit"} modalContent={"deleteBulkBuildingModalContent"} modalName={"bulkdeletebuildingmodal"}
                deletePerform={() => deleteBuildingPerform("bulkDeleteBuildingSubmit", "loadBulkDeleteBuildingSubmit", "bulkConfirmBuildingClose", ppRules3.start, ppRules3.end)}
                start={ppRules3.start} end={ppRules3.end} header={"Delete Buildings"}/>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                          setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                          setPage={(sudocode) => setPage(sudocode)}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Areas Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The Areas page allows you to manage areas, area groups, and buildings in your community. 
                                    Use the tabs at the top to switch between Areas, Area Groups, and Buildings.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Filtering
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Search Bar:</strong> Use the search bar to quickly find areas, groups, or buildings by name, description, or address.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Column Filters:</strong> Click the filter icons in column headers to filter by specific criteria.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Tab Navigation:</strong> Switch between Areas, Area Groups, and Buildings using the tabs above the table.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-map-pin me-2 text-primary"}></i>Managing Areas
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the <strong>"New Area"</strong> button to add a new area.
                                    </li>
                                    <li className={"mb-2"}>
                                        Fill in required fields: Name, Area Type, Building, and Max Occupancy.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Single Add:</strong> Add one area at a time with full customization.
                                    </li>
                                    {iAmHigherAuthority(80, dData.role_weight)
                                        ?   <li className={"mb-2"}>
                                                <strong>Bulk Add:</strong> (Tech only) Add multiple areas at once using a prefix and number range (e.g., "Room 1" through "Room 10").
                                            </li>
                                        :   <></>
                                    }
                                    <li className={"mb-2"}>
                                        Assign areas to groups by checking the boxes in the Groups section.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon in any row to modify area information, assign devices, or update groups.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-users me-2 text-primary"}></i>Area Groups
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Area Groups help organize related areas together for easier management.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"New Group"</strong> to create a new area group.
                                    </li>
                                    <li className={"mb-2"}>
                                        Assign multiple areas to a group by checking the boxes next to area names.
                                    </li>
                                    <li className={"mb-2"}>
                                        Edit groups to add or remove areas, or update the group name and description.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-home me-2 text-primary"}></i>Buildings
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Buildings represent physical structures in your community.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"New Building"</strong> to add a new building with address information.
                                    </li>
                                    <li className={"mb-2"}>
                                        Fill in building details: Name, Country, State, Street Address, City, and Zipcode.
                                    </li>
                                    <li className={"mb-2"}>
                                        Assign areas to buildings when creating or editing areas.
                                    </li>
                                    <li className={"mb-2"}>
                                        Edit buildings to update address information or reassign areas.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-smartphone me-2 text-primary"}></i>Managing Devices
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        View assigned devices in the edit area modal's Devices section.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the <strong>"Device"</strong> button to add a new device to an area.
                                    </li>
                                    <li className={"mb-2"}>
                                        Remove devices by clicking the trash icon next to the device name.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use "Auto Listen" for Inovonics devices to automatically detect new devices upon activation.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Community Devices:</strong> Regular devices assigned to areas.
                                    </li>
                                    {iAmHigherAuthority(80, dData.role_weight)
                                        ?   <li className={"mb-2"}>
                                                <strong>System Devices:</strong> (Tech only) Network coordinators and repeaters for system infrastructure.
                                            </li>
                                        :   <></>
                                    }
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-download me-2 text-primary"}></i>Exporting Data
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the <strong>"Export"</strong> button to download data as a CSV file.
                                    </li>
                                    <li className={"mb-2"}>
                                        The export includes all visible columns and respects current filters.
                                    </li>
                                    <li className={"mb-2"}>
                                        Export format changes based on the active tab (Areas, Area Groups, or Buildings).
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Items
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Select one or more items using the checkboxes.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Delete"</strong> to remove selected items.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Note:</strong> Deleting an area will also remove all devices assigned to it.
                                    </li>
                                    <li className={"mb-2"}>
                                        Deleting a building will unassign areas from that building (areas are not deleted).
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click column headers to sort the table by that column.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the pagination controls at the bottom to navigate through multiple pages.
                                    </li>
                                    <li className={"mb-2"}>
                                        Adjust the number of items per page using the page size button.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click on area names to navigate to their profile pages.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Max Occupancy:</strong> Set to 0 for common areas, or 1-4 for resident rooms.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Bulk Add:</strong> Maximum of 500 areas can be added at once in bulk mode.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Areas;